/*
 * Copyright (c) 2017 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Site } from '../models';
import { Equipment } from '../models/equipment.model';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';


@Injectable()
export class SiteService {
    api_url: string;
    constructor(private apiService: ApiService) {
        this.api_url = environment.cdt.api_url;
    }

    list(): Observable<[Site]> {
        return this.apiService.get('sites/', this.api_url)
            .map(data => data);
    }

    listEquipments(siteId: string): Observable<[Equipment]> {
        return this.apiService.get('sites/' + siteId + '/equipments', this.api_url);
    }

    publish(siteId: string): Observable<any> {
        return this.apiService.post('sites/publish', this.api_url, JSON.stringify({ 'siteId': siteId }));
    }

    publishWithAnalytics(siteId: string, isSetupAnalyticsRequired: boolean, timezone: string): Observable<any> {
        const requestBody = {
            siteId: siteId,
            publishSettings: {
                isAutomaticAnalyticsSetupRequired: isSetupAnalyticsRequired,
                timeZone: timezone
            }
        };
        return this.apiService.post('sites/publish', this.api_url, JSON.stringify(requestBody));
    }

    getModelId(organizationId: string): Observable<string> {
        return this.apiService.get('sites/model?organizationId=' + organizationId, this.api_url);
    }

    publishHistory() {
        return this.apiService.post('sites/publish/history', this.api_url);
    }

    getTimezoneConfiguredToPublishWithAutoSetupAnalytics(modelId: string): Observable<string> {
        return this.apiService.get('sites/' + modelId + '/publish/analytics/timezone', this.api_url, new HttpParams(), 'text' as 'json');
    }
}
